import { AlertService } from './alert.service';
import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';
import * as AlertActions from './alert.action';
import * as AlertModels from '../../models/alert/alert';
import * as AlertSummaryModels from '../../models/alert/alertSummary';
import * as AlertTitleModels from '../../models/alert/alertTitle';
import { AlertSearchModel } from '../../models/alert/alertSearch';
import { BannerService } from '../../shared/services/banner.service';
import { SaveState } from '../../models/commonModels';
import { HelperService } from '../../../../src/app/services/helper/helper.service';

export interface AlertStateModel {
  AlertSave: SaveState;
  AlertTitles: AlertTitleModels.AlertTitleListModel;
  AlertList: AlertModels.AlertListModel;
  AlertSummaryList: AlertSummaryModels.AlertSummaryListModel;
  Alert: AlertModels.AlertModel;
  AlertSearch: AlertSearchModel;
}

@State<AlertStateModel>({
    name: 'alertState',
    defaults: {
      AlertList: null,
      AlertSave: null,
      AlertTitles: null,
      AlertSummaryList: null,
      Alert: null,
      AlertSearch: null
    }
})

@Injectable()

export class AlertState {

    constructor(
                private helperService: HelperService,
                private alertService: AlertService,
                private bannerService: BannerService
                ) { }

  @Selector()
  static AlertList(state: AlertStateModel) {
    return state.AlertList;
  }

  @Selector()
  static AlertSave(state: AlertStateModel) {
    return state.AlertSave;
  }

  @Selector()
  static AlertTitles(state: AlertStateModel) {
    return state.AlertTitles;
  }

  @Selector()
  static AlertSummaryList(state: AlertStateModel) {
    return state.AlertSummaryList;
  }

  @Selector()
  static Alert(state: AlertStateModel) {
    return state.Alert;
  }

  @Selector()
  static AlertSearch(state: AlertStateModel) {
    return state.AlertSearch;
  }

  @Action(AlertActions.SetAlert)
  setAlert(
    context: StateContext<AlertStateModel>,
    action: AlertActions.SetAlert
  ) {
    const errorMessage = 'Błąd zapisu szczegółów alertu.';

    this.alertService.set(action.Alert).subscribe(
      ret => {
        this.bannerService.success('Zmiany szczegółów alertu zapisane.');

        context.setState(
          patch({
            AlertSave: new SaveState(action.Alert.AlertId, true)
          })
        );

        context.dispatch(new AlertActions.Refresh(action.Alert));
      },

      (error) => {

        context.setState(
          patch({
            AlertSave: new SaveState(action.Alert.AlertId, false)
          })
        );


        this.helperService.SaveException('CarActions.SetCar', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(AlertActions.GetAlertList)
  getAlertList(
    context: StateContext<AlertStateModel>,
    action: AlertActions.GetAlertList
  ) {

    const errorMessage = 'Błąd pobierania listy alertów.';

    context.setState(
      patch({
        AlertList: null
      })
    );

    this.alertService.getList(action.Search).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            AlertList: ret
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('AlertActions.GetAlertList', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(AlertActions.GetAlert)
  getAlert(
    context: StateContext<AlertStateModel>,
    action: AlertActions.GetAlert
  ) {

    const errorMessage = 'Błąd pobierania szczegółów alertu.';

    context.setState(
      patch({
        Alert: null
      })
    );

    this.alertService.get(action.AlertId).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            Alert: ret.Item
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('AlertActions.GetAlert', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(AlertActions.Refresh)
  Refresh(
    context: StateContext<AlertStateModel>,
    action: AlertActions.Refresh
  ) {

    const errorMessage = 'Błąd pobierania szczegółów alertu.';

    this.alertService.get(action.Alert.AlertId).subscribe((ret) => {
      if (ret.Success) {

        action.Alert.DisactivatedByUser = ret.Item.DisactivatedByUser;
        action.Alert.DisactivatedByUserId = ret.Item.DisactivatedByUserId;

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('AlertActions.Refresh', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(AlertActions.GetAlertSummary)
  getAlertSummary(
    context: StateContext<AlertStateModel>
  ) {

    const errorMessage = 'Błąd pobierania statystyki alertów.';

    context.setState(
      patch({
        AlertSummaryList: null
      })
    );

    this.alertService.getSummary().subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            AlertSummaryList: ret
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('AlertActions.GetAlertSummary', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(AlertActions.GetAlertTitleDictionary)
  getAlertTitleDictionary(
    context: StateContext<AlertStateModel>
  ) {

    const errorMessage = 'Błąd pobierania statystyki alertów.';

    const state = context.getState();

    if (!state.AlertTitles) {

      this.alertService.getTitleDictionary().subscribe((ret) => {
        if (ret.Success) {
          context.setState(
            patch({
              AlertTitles: ret
            })
          );

          return ret;

        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },
        (error) => {
          this.helperService.SaveException('AlertActions.GetAlertTitleDictionary', error);

          this.bannerService.error(errorMessage);
        });
    }
  }

  @Action(AlertActions.SetAlertSearch)
  setAlertSearch(
    context: StateContext<AlertStateModel>,
    action: AlertActions.SetAlertSearch
  ) {

    action.Search.CurrentPage = 1;

    context.setState(
      patch({
        AlertSearch: action.Search
      }));

    context.dispatch(new AlertActions.GetAlertList(action.Search));
  }

  @Action(AlertActions.SetAlertListPage)
  setDepositeListPage(
    context: StateContext<AlertStateModel>,
    action: AlertActions.SetAlertListPage
  ) {

    context.setState(
      patch({
        AlertSearch: action.Search
      }));

    context.dispatch(new AlertActions.GetAlertList(action.Search));
  }

  @Action(AlertActions.ResetAlertSearch)
  resetDepositeSearch(
    context: StateContext<AlertStateModel>
  ) {

    const state = context.getState();

    const alertSearch = new AlertSearchModel();

    alertSearch.ItemsPerPage = state.AlertSearch.ItemsPerPage;

    context.setState(
      patch({
        AlertSearch: alertSearch
      }));

    context.dispatch(new AlertActions.GetAlertList(state.AlertSearch));
  }
}
